import { useGetOrganization } from "@vendata/power-up-sdk";

export function useCompanyProfileLoader() {
  return {
    organizationQuery: useGetOrganization(),
  };
}
